import { Wrapper, Title, List, ListItem } from './styles'
import { TrendsBlockProps } from './types'

export function TrendsBlock({ list, title }: TrendsBlockProps) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <List>
        {list.map(({ id, text }) => (
          <ListItem key={id}>{text}</ListItem>
        ))}
      </List>
    </Wrapper>
  )
}
